<img *ngFor='let url of urls'  [src]="url" height="200"> <br/>

<input type='file' (change)="onSelectFile($event)" multiple>
